import type { RootStore } from '~/stores/root.store';
import {
    AllInboundEvents,
    IMobileAppService
} from '~/components/Builder/Mobile/builderMobileApi.types';
import { FlowMXContextValue } from '~/components/Builder/FlowMX.provider';

class BaseAbstractBuilderApi {
    rootStore: RootStore;
    flowMXContext: FlowMXContextValue;
    MobileAppService: IMobileAppService;

    constructor(
        rootStore: RootStore,
        flowMXContext: FlowMXContextValue,
        MobileAppService: IMobileAppService
    ) {
        this.rootStore = rootStore;
        this.flowMXContext = flowMXContext;
        this.MobileAppService = MobileAppService;
    }

    subscribeToEvent(eventName: AllInboundEvents) {
        this.MobileAppService.on(
            eventName,
            event => {
                this[eventName](event);
            },
            this
        );
    }
    unsubscribe() {
        if (this.MobileAppService?.offAll) {
            this.MobileAppService.offAll(this);
        }
    }
}

export default BaseAbstractBuilderApi;
